import HoursDashboard from "./HoursDashboard";

export default HoursDashboard;
